'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { cn } from '@src/utils/tailwind';
import { textStyleMap } from '../Builder/Text/Text';
export const BannerAlignment = ['left', 'center', 'right'] as const;
export const FontStyles = Object.values(textStyleMap);
interface OfferCardsProps {
  children?: ReactNode;
  backgroundColor?: string;
  featuredLabel?: string;
  featuredLabelPadding?: number;
  featuredFontStyle?: (typeof FontStyles)[number];
  featuredFontColor?: string;
  featuredColor?: string;
  featuredBorderWidth?: number;
  featuredBannerAlignment?: (typeof BannerAlignment)[number];
}
const cardClasses = 'flex min-h-[200px] w-full flex-1 flex-col rounded-3xl border border-bodi-gray-butters p-10 self-center';
const featuredCardClasses = 'border-2 relative pt-11';
export const OfferCard = props => {
  const $ = _c(23);
  const {
    isMobile,
    isTablet
  } = useBreakpoints();
  const {
    children,
    backgroundColor: t0,
    featuredColor: t1,
    featuredLabel,
    featuredLabelPadding: t2,
    featuredFontStyle: t3,
    featuredFontColor: t4,
    featuredBorderWidth: t5,
    featuredBannerAlignment: t6
  } = props;
  const backgroundColor = t0 === undefined ? "#FFFFFF" : t0;
  const featuredColor = t1 === undefined ? "#825BB5" : t1;
  const featuredLabelPadding = t2 === undefined ? 16 : t2;
  const featuredFontStyle = t3 === undefined ? "text-body-md" : t3;
  const featuredFontColor = t4 === undefined ? "white" : t4;
  const featuredBorderWidth = t5 === undefined ? 2 : t5;
  const featuredBannerAlignment = t6 === undefined ? "center" : t6;
  let t7;
  if ($[0] !== featuredBorderWidth || $[1] !== featuredColor || $[2] !== featuredLabel) {
    t7 = featuredLabel ? {
      borderColor: featuredColor,
      borderWidth: featuredBorderWidth
    } : undefined;
    $[0] = featuredBorderWidth;
    $[1] = featuredColor;
    $[2] = featuredLabel;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const borderStyles = t7;
  const bannerAlignment = isMobile || isTablet ? "center" : featuredBannerAlignment;
  const baseLabelYPadding = isMobile || isTablet ? Math.ceil(featuredLabelPadding / 6) - 4 : Math.ceil(featuredLabelPadding / 6);
  const t8 = !!featuredLabel;
  const t9 = !!featuredLabel;
  let t10;
  if ($[4] !== t8 || $[5] !== t9) {
    t10 = cn(cardClasses, {
      [featuredCardClasses]: t8,
      "order-first lg:order-0": t9
    });
    $[4] = t8;
    $[5] = t9;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] !== backgroundColor || $[8] !== borderStyles) {
    t11 = {
      ...borderStyles,
      backgroundColor
    };
    $[7] = backgroundColor;
    $[8] = borderStyles;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== bannerAlignment || $[11] !== baseLabelYPadding || $[12] !== featuredColor || $[13] !== featuredFontColor || $[14] !== featuredFontStyle || $[15] !== featuredLabel || $[16] !== featuredLabelPadding) {
    t12 = featuredLabel && <span className={cn(`absolute top-0 rounded-b-md whitespace-nowrap${featuredFontStyle}`, {
      "left-1/2 -translate-x-1/2": bannerAlignment === "center",
      "left-10": bannerAlignment === "left",
      "right-10": bannerAlignment === "right"
    })} style={{
      backgroundColor: featuredColor,
      color: featuredFontColor,
      padding: `${baseLabelYPadding}px ${Math.max(featuredLabelPadding, 4)}px`
    }}>{featuredLabel}</span>;
    $[10] = bannerAlignment;
    $[11] = baseLabelYPadding;
    $[12] = featuredColor;
    $[13] = featuredFontColor;
    $[14] = featuredFontStyle;
    $[15] = featuredLabel;
    $[16] = featuredLabelPadding;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== children || $[19] !== t10 || $[20] !== t11 || $[21] !== t12) {
    t13 = <div className={t10} style={t11}>{t12}{children}</div>;
    $[18] = children;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};